<div *ngIf="!showLoading" class="main-container">
    <div class="header">
        <img src="assets/images/Rectangle 25996.png" alt="Welcome" class="background-image">
        <p class="heading">{{cfetLabels.utf_customer_landing_new.header_content}}</p>
    </div>
    <div class="content">
        <p class="content-id">{{cfetLabels.utf_customer_landing_new.enter_affiliation_or_association}}</p>
        <div class="input-group form-group">
            <form [formGroup]="affiliationCodeForm" (ngSubmit)="onSubmitAffiliationCode($event)">
                <input type="text" aria-label="enter affliation code" class="form-control" id="affiliation"
                    formControlName="affiliationCode" (keydown)="onSubmitAffiliationCode($event)">
                <em><button class="btn" (click)="onSubmitAffiliationCode($event)"
                        (keydown)="onSubmitAffiliationCode($event)"
                        tabindex="0">{{cfetButtonLabels.button_labels.continue}}</button></em>
            </form>
        </div>
        <div class="alternative-option">
            <p class="content-id">{{cfetLabels.utf_customer_landing_new.no_affCode}}</p>
            <p class="eligibility-text">
                {{cfetLabels.utf_customer_landing_new.continue_without_code}}<br>{{cfetLabels.utf_customer_landing_new.
                eligibility_text}}</p>
            <button type="button" class="btn-outline"
                (click)="eligibility($event)">{{cfetButtonLabels.button_labels.continue_without_code}}</button>
        </div>
    </div>
</div>

<div [ngClass]="(showBadCodeModal === true) ? 'bad-code-modal' : ''" class="container-fluid">
    <app-bad-code-modal [openModal]="openBadCodeModal" (modalCloseEvent)="closeBadCodeModal($event)">
    </app-bad-code-modal>
</div>
<app-custom-spinner *ngIf="showLoading"></app-custom-spinner>